// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"820e2484","203":"820e2484","344":"820e2484","736":"820e2484"}[chunkId] + ".chunk.css";
};